import { RestClient } from "clients/rest";
import { systemCd } from "services/codes";

export type SystemProperties = { systemCd: number };

export const MSystemGet = () => {
  return RestClient.get("msystem/get", {
    params: { systemCd: systemCd },
  });
};
